import { jsx as _jsx } from "react/jsx-runtime";
import commonPropTypes from '../../../../constants/commonPropTypes';
import React, { Component } from 'react';
import classnames from 'classnames/bind';
import styles from '../styles.scss';
const cx = classnames.bind(styles);
class FieldError extends Component {
    static propTypes = {
        ...commonPropTypes,
    };
    render() {
        const { className, elmId, error } = this.props;
        return (_jsx("div", { "data-elm-id": `${elmId}_error`, className: cx('error', className), children: error }));
    }
}
export default FieldError;
//# sourceMappingURL=index.js.map